import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05c7512a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth-modal" }
const _hoisted_2 = {
  key: 0,
  class: "main-color align-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "second-color xs-font-size" }, "При регистрации и входе вы соглашаетесь с условиями использования \"Мой ИЖС\" и политикой конфиденциальности.", -1))
const _hoisted_4 = { class: "items-in-line gap--5 flex-start" }

import { Ref, ref } from 'vue';
import { useVuelidate, ValidationRuleWithoutParams } from '@vuelidate/core';
import { email, required } from '@vuelidate/validators';
import {
  errorsHandler,
  errorsHandlerByKey,
  validationErrorsByRequest,
} from '@/utils/Common/Common';
import { ErrorsType } from '@/types';
import { useUserStore } from '@/store/modules/user';
import { useAppStore } from '@/store/modules/app';

type FormDataType = {
  email: string | undefined;
  password: string | undefined;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'LoginModal',
  props: {
    showModal: { type: Boolean }
  },
  emits: ['close', 'showPasswordRecoveryModal', 'showRegistrationModal'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const formData: Ref<FormDataType> = ref({
  email: undefined,
  password: undefined,
});

const clearFormData = () => {
  v$.value.$reset();
  for (const [key] of Object.entries(formData)) {
    formData.value[key as keyof FormDataType] = undefined;
  }
};

const rules: { [key: string]: { [key: string]: ValidationRuleWithoutParams } } = {
  email: { required, email },
  password: { required },
};
const v$ = useVuelidate<FormDataType>(rules, formData);

const errors: Ref<ErrorsType> = ref({});

const validationErrorsHandlerByKey = (key: string) => {
  let error: string | undefined = errorsHandlerByKey(key, rules, v$);

  if (error) {
    errors.value[key] = error;
  } else {
    delete errors.value[key];
  }
};
const validationErrorsHandler = () => {
  errors.value = errorsHandler(formData.value, rules, v$);
};

const loading = ref(false);
const formSubmit = async () => {
  if (v$.value.$invalid) {
    v$.value.$touch();
    validationErrorsHandler();

    return;
  }
  loading.value = true;
  try {
    await useUserStore().asyncLogin(formData.value);
    clearFormData();
    emit('close');
    localStorage.setItem('auth-event', 'login' + Math.random());
  } catch (error) {
    errors.value = validationErrorsByRequest(error);
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_form = _resolveComponent("base-form")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    "show-modal": _ctx.showModal,
    title: "Войти",
    onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('close')))
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(useAppStore)().showAuthMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Доступ откроется при входе в личный кабинет "))
          : _createCommentVNode("", true),
        _createVNode(_component_base_form, { class: "grid--1 gap--15" }, {
          default: _withCtx(() => [
            _createVNode(_component_base_input, {
              modelValue: formData.value.email,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.email) = $event)),
              error: errors.value.email,
              invalid: !!errors.value.email,
              height: "40",
              label: "E-mail",
              onBlur: _cache[1] || (_cache[1] = ($event: any) => (validationErrorsHandlerByKey('email'))),
              onFocus: _cache[2] || (_cache[2] = ($event: any) => (delete errors.value.email)),
              onInput: _unref(v$).email.$touch
            }, null, 8, ["modelValue", "error", "invalid", "onInput"]),
            _createVNode(_component_base_input, {
              modelValue: formData.value.password,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.password) = $event)),
              error: errors.value.password,
              invalid: !!errors.value.password,
              height: "40",
              label: "Пароль",
              type: "password",
              onBlur: _cache[4] || (_cache[4] = ($event: any) => (validationErrorsHandlerByKey('password'))),
              onFocus: _cache[5] || (_cache[5] = ($event: any) => (delete errors.value.password)),
              onInput: _unref(v$).password.$touch
            }, null, 8, ["modelValue", "error", "invalid", "onInput"]),
            _createElementVNode("button", {
              class: "main-color align-right",
              type: "button",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('showPasswordRecoveryModal')))
            }, " Забыли пароль? ")
          ]),
          _: 1
        }),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createTextVNode(" Нет аккаунта? "),
          _createElementVNode("button", {
            class: "gradient-color gradient-underline",
            type: "button",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('showRegistrationModal')))
          }, " Зарегистрироваться ")
        ])
      ])
    ]),
    btn: _withCtx(() => [
      _createVNode(_component_base_button, {
        loading: loading.value,
        height: "40",
        text: "Войти",
        onClick: formSubmit
      }, null, 8, ["loading"])
    ]),
    _: 1
  }, 8, ["show-modal"]))
}
}

})